import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyUploadCoversheet = lazy(() => import('./svg-components/upload-coversheet'));

const UploadCoversheet = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyUploadCoversheet {...rest} />
  </Suspense>
);

export default UploadCoversheet;
